const question = {
    yes: { point: [2] },
    no: { point: [0] },
};

export default question;
